import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors } from '@/utils/constants';

const useStyles = makeStyles(
  (muiTheme) => ({
    container: {
      '& > * + *': {
        marginTop: '32px',
      },
    },
    doubleSpacing: {
      '&:not(:first-child)': {
        marginTop: '58px',
      },

      '& + *': {
        marginTop: '58px',
      },
    },
    inset: {
      [muiTheme.breakpoints.up('md')]: {
        padding: '0 32px',
      },
    },
    offset: {
      [muiTheme.breakpoints.up('md')]: {
        marginLeft: '-32px',
        marginRight: '-32px',
      },
    },
    rtc: {
      '&.dark-theme': {
        '& h5': {
          color: SecondaryColors.main,
        },
      },

      '&.light-theme': {
        '& h5': {
          color: SecondaryColors.dark,
        },
      },
    },
    columnContent: {
      '& .columns': {
        '& .column': {
          '& > * + *': {
            marginTop: muiTheme.spacing(3),
          },
        },
      },
    },
    columnCenterAlign: {
      '& .columns': {
        alignItems: 'center',
        alignContent: 'center',
      },
    },
    columnBottomAlign: {
      '& .columns': {
        alignItems: 'flex-end',
        alignContent: 'flex-end',
      },
    },
  }),
  { name: 'GenCustomerStoryContent' },
);

export default useStyles;
